export const scheduleTimezone =
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export function localScheduleInput(value) {
  if (!value) return "";
  const date = new Date(value);
  const pad = (number) => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function scheduleTimestamp(value) {
  const date = new Date(value);
  if (
    !value ||
    !Number.isFinite(date.getTime()) ||
    localScheduleInput(date) !== value ||
    date.getTime() <= Date.now()
  ) {
    throw new Error("Choose a valid future date and time.");
  }
  return date.toISOString();
}

export function nextAnnouncementPickup(value) {
  const timestamp = new Date(value).getTime();
  // Beat runs at :15/:45 UTC. Round upwards without changing the chosen date.
  return new Date(Math.ceil((timestamp - 900000) / 1800000) * 1800000 + 900000);
}

export function displaySchedule(value) {
  return new Date(value).toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  });
}
